import { render } from "./UserCardsPacks.vue?vue&type=template&id=2dc83b0a&scoped=true"
import script from "./UserCardsPacks.vue?vue&type=script&lang=js"
export * from "./UserCardsPacks.vue?vue&type=script&lang=js"

import "./UserCardsPacks.vue?vue&type=style&index=0&id=2dc83b0a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc83b0a"]])

export default __exports__